import Enumeration from "../domain/Enumeration";

const LimitIncreaseDocumentType = new Enumeration({
    PROOF_OF_ADDRESS: "PROOF_OF_ADDRESS",
    PROOF_OF_INCOME: "PROOF_OF_INCOME"
});
export default LimitIncreaseDocumentType;
